import * as React from 'react'
import { withConfig } from  '../../common/modules/config'
import { withCobrand } from '../../common/modules/cobrand'
import './header.css'

interface Props{
    logo:string
    cobrand?:any
}


@withConfig
@withCobrand
class Header extends React.Component<Props, any>{

    render(){
        return (
            <div className="header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <img className="chu-logo" src={ this.props.logo } />
                            { this.props.cobrand.loaded
                                && <a href={ this.props.cobrand.url } target="_blank"><img className="cobrand-logo ml-0 ml-md-4" src={ this.props.cobrand.logoURL } /></a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


export default Header;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/header.tsx